import { Box, MaskedInput, MaskedInputExtendedProps, Text } from 'grommet'
import { Controller, useFormContext } from 'react-hook-form'

interface TimeInputProps extends MaskedInputExtendedProps {
  name: string
  label: string
  errorMessage?: string
  is24HourFormat?: boolean
  customMask?: Array<any>
}

export const TimeInputField = ({
  label,
  name,
  errorMessage,
  is24HourFormat = false,
  customMask,
  ...rest
}: TimeInputProps) => {
  const {
    control,
    formState: { errors }
  } = useFormContext()
  const errorText = errors[name]?.message
  const displayError = errorText && typeof errorText === 'string' ? errorText : errorMessage

  const mask = is24HourFormat
    ? [
        {
          length: [1, 2],
          options: Array.from({ length: 24 }, (v, k) => k),
          placeholder: 'hh',
          regexp: /^(0?[0-9]|1[0-9]|2[0-3])$/
        },
        { fixed: ':' },
        {
          length: 2,
          options: ['00', '15', '30', '45'],
          placeholder: 'mm',
          regexp: /^[0-5][0-9]$/
        }
      ]
    : [
        {
          length: [1, 2],
          options: Array.from({ length: 12 }, (v, k) => k + 1),
          placeholder: 'hh',
          regexp: /^1[0,1-2]$|^0?[1-9]$|^0$/
        },
        { fixed: ':' },
        {
          length: 2,
          options: ['00', '15', '30', '45'],
          placeholder: 'mm',
          regexp: /^[0-5][0-9]$|^[0-9]$/
        },
        { fixed: ' ' },
        {
          length: 2,
          options: ['am', 'pm'],
          placeholder: 'ap',
          regexp: /^[ap]m$|^[AP]M$|^[aApP]$/
        }
      ]

  return (
    <>
      {label && (
        <Text margin={{ bottom: '2px' }} style={{ fontSize: '14px', fontWeight: 500 }}>
          {label}
        </Text>
      )}
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value } }) => (
          <MaskedInput
            mask={customMask || mask}
            onChange={selectedVal => {
              onChange(selectedVal)
            }}
            value={value}
            {...rest}
          />
        )}
      />
      {displayError && (
        <Box pad={{ left: 'small' }}>
          <Text color="status-error" size="small">
            {displayError}
          </Text>
        </Box>
      )}
    </>
  )
}
